export const SCREENS = {
    INITIAL: 'initial',
    OTP: 'otp',
    CONSENTS: 'consents',
} as const;

export const FIELD_NAME = {
    PHONE: 'phone',
    NAME: 'name',
    OTP: 'code',
    EMAIL: 'email',
    AGREEMENT_PERSONAL_DATA: 'agreementPersonalData',
    AGREEMENT_ADVERTISING: 'agreementAdvertising',
    REFERENCE_TOKEN: 'referenceToken',
    SERVER: 'root.server',
} as const;

export const FORM_ID = 'sravniAuthInlineForm';
export const UNAUTHORIZED_ERROR_TYPE = 'unauthorized';
